var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearch,"trigger-on-focus":false},on:{"select":_vm.handleSelect},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe782dea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExtensionChoseMedium.vue
// module id = null
// module chunks = 